// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament_match_admin_filter_buttons {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: var(--space);
    position: relative;
    gap:var(--space)
}

.tournament_match_all_filters_button_container{
    position: relative;
}

.tournament_match_all_filters_buttons{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    border: 0.5px solid #CDCDCD;
    border-radius: 5px;
    background-color: var(--white-color);
    gap: 6px;
    padding: var(--space-half);
}

.tournament_match_filter_button_callsign{
    display:flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
}

.tournament_match_filter_button_callsign__used {
    display: flex;
    align-items: center;
    gap: 4px;
}

.tournament_match_all_filters_buttons._active{
    background: #E6F6EC;
    border-color:var( --new-green-color);
}

.tournament_match_all_filters_buttons._active .icon-x:hover{
    cursor: pointer;
}

.tournament_match_all_filters_buttons._active .tournament_match_filter_button_callsign .baloa-table{
    color: var( --new-green-color);
}

.tournament_match_all_filters_buttons._active .tournament_match_filter_button_callsign .baloa-table.number_circle{
    background:var( --new-green-color);
    width: 18px;
    height: 18px;
    border-radius: 50%;
    display: grid;
    align-items: center;
    align-content: center;
    justify-content: center;
    margin-top: 2px;
    color: white;
}

.tournament_match_all_filters_buttons .hubicon-expand_more{
    font-size: var(--space-and-half);
}

.tournament_match_filter_button {
    display: grid;
    justify-content: center;
}

.tournament_match_filter_button:hover {
    cursor: pointer;
}

.tournament_match_dropdown-content {
    display: none;
    position: absolute;
    width: auto;
    overflow: auto;
    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.082);
    background-color: var(--white-color);
    /* padding: 0 var(--space); */
    border-radius: var(--space-half);
    top: 45px;
    z-index: 1;
}

.tournament_match_dropdown-content._active{
    display: block;
}

.tournament_match_dropdown-content._active .tournament_match_dropdown-content_title .baloa-table{
    font-weight: var(--font-medium);
}

.tournament_match_dropdown-content._active .tournament_match_dropdown-content_title .icon-x{
    font-size: 24px;
}

.tournament_match_dropdown-content._active .tournament_match_dropdown-content_title .icon-x:hover{
    cursor: pointer;
}

.tournament_match_dropdown-content_title{
    display: flex;
    justify-content: space-between;
    padding: var(--space);
    position: sticky;
    top: 0;
    background: var(--white-color);
    z-index: 4;
    border-bottom: 1px solid var(--new-gray-background-color);
}

.tournament_match_filter_actions{
    display:flex;
    justify-content: flex-end;
}

.tournament-match-admin-filter__date-picker__container {
    position: relative;
    
}

.tournament-match-admin-filter__date-picker__input {
    position: absolute;
    max-width: 90px;
    transform: none !important;
}

.tournament-match-admin-filter__date-picker__container .react-datepicker-wrapper{
    display: none;
}

.tournament_match_admin_filter_actions{
    display:flex;
    justify-content: flex-end;
    padding: var(--space-half) var(--space-half-quarter);
    border-top: 1px solid var(--new-gray-background-color);
}

.tournament_match_admin_filter_actions .secondary-button {
    border: none;
    color: var(--basic-gray-color);
}

.tournament_match_admin_filter_actions .secondary-button:hover,
.tournament_match_admin_filter_actions .secondary-button:focus,
.tournament_match_admin_filter_actions .secondary-button:active{
    background-color: transparent;
    color: var(--basic-gray-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .tournament_match_dropdown-content {
        right: 0;
    }

    .tournament_match_all_filters_button_container{
        position: unset;
    }

    .tournament_match_admin_filter_buttons {
        flex-wrap: wrap;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-match-admin-filter/TournamentMatchAdminFilterComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,oCAAoC;IACpC,QAAQ;IACR,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;IAClC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,kDAAkD;IAClD,oCAAoC;IACpC,6BAA6B;IAC7B,gCAAgC;IAChC,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,gBAAgB;IAChB,MAAM;IACN,8BAA8B;IAC9B,UAAU;IACV,yDAAyD;AAC7D;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;;AAEtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,oDAAoD;IACpD,sDAAsD;AAC1D;;AAEA;IACI,YAAY;IACZ,8BAA8B;AAClC;;AAEA;;;IAGI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".tournament_match_admin_filter_buttons {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-bottom: var(--space);\n    position: relative;\n    gap:var(--space)\n}\n\n.tournament_match_all_filters_button_container{\n    position: relative;\n}\n\n.tournament_match_all_filters_buttons{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: row;\n    border: 0.5px solid #CDCDCD;\n    border-radius: 5px;\n    background-color: var(--white-color);\n    gap: 6px;\n    padding: var(--space-half);\n}\n\n.tournament_match_filter_button_callsign{\n    display:flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 5px;\n}\n\n.tournament_match_filter_button_callsign__used {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.tournament_match_all_filters_buttons._active{\n    background: #E6F6EC;\n    border-color:var( --new-green-color);\n}\n\n.tournament_match_all_filters_buttons._active .icon-x:hover{\n    cursor: pointer;\n}\n\n.tournament_match_all_filters_buttons._active .tournament_match_filter_button_callsign .baloa-table{\n    color: var( --new-green-color);\n}\n\n.tournament_match_all_filters_buttons._active .tournament_match_filter_button_callsign .baloa-table.number_circle{\n    background:var( --new-green-color);\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    display: grid;\n    align-items: center;\n    align-content: center;\n    justify-content: center;\n    margin-top: 2px;\n    color: white;\n}\n\n.tournament_match_all_filters_buttons .hubicon-expand_more{\n    font-size: var(--space-and-half);\n}\n\n.tournament_match_filter_button {\n    display: grid;\n    justify-content: center;\n}\n\n.tournament_match_filter_button:hover {\n    cursor: pointer;\n}\n\n.tournament_match_dropdown-content {\n    display: none;\n    position: absolute;\n    width: auto;\n    overflow: auto;\n    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.082);\n    background-color: var(--white-color);\n    /* padding: 0 var(--space); */\n    border-radius: var(--space-half);\n    top: 45px;\n    z-index: 1;\n}\n\n.tournament_match_dropdown-content._active{\n    display: block;\n}\n\n.tournament_match_dropdown-content._active .tournament_match_dropdown-content_title .baloa-table{\n    font-weight: var(--font-medium);\n}\n\n.tournament_match_dropdown-content._active .tournament_match_dropdown-content_title .icon-x{\n    font-size: 24px;\n}\n\n.tournament_match_dropdown-content._active .tournament_match_dropdown-content_title .icon-x:hover{\n    cursor: pointer;\n}\n\n.tournament_match_dropdown-content_title{\n    display: flex;\n    justify-content: space-between;\n    padding: var(--space);\n    position: sticky;\n    top: 0;\n    background: var(--white-color);\n    z-index: 4;\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.tournament_match_filter_actions{\n    display:flex;\n    justify-content: flex-end;\n}\n\n.tournament-match-admin-filter__date-picker__container {\n    position: relative;\n    \n}\n\n.tournament-match-admin-filter__date-picker__input {\n    position: absolute;\n    max-width: 90px;\n    transform: none !important;\n}\n\n.tournament-match-admin-filter__date-picker__container .react-datepicker-wrapper{\n    display: none;\n}\n\n.tournament_match_admin_filter_actions{\n    display:flex;\n    justify-content: flex-end;\n    padding: var(--space-half) var(--space-half-quarter);\n    border-top: 1px solid var(--new-gray-background-color);\n}\n\n.tournament_match_admin_filter_actions .secondary-button {\n    border: none;\n    color: var(--basic-gray-color);\n}\n\n.tournament_match_admin_filter_actions .secondary-button:hover,\n.tournament_match_admin_filter_actions .secondary-button:focus,\n.tournament_match_admin_filter_actions .secondary-button:active{\n    background-color: transparent;\n    color: var(--basic-gray-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .tournament_match_dropdown-content {\n        right: 0;\n    }\n\n    .tournament_match_all_filters_button_container{\n        position: unset;\n    }\n\n    .tournament_match_admin_filter_buttons {\n        flex-wrap: wrap;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
